export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    "verification-types": {
        menu: {
            index: 'احراز هویت',
            create: 'جدید',
            list: 'احراز هویت'
        },
        table_titles: {
            id: 'شناسه',
            country: 'کشور',
            communication_type: 'نوع ارتباط',
            kyc_method: 'روش احراز هویت',
            instructions: 'دستورالعمل‌ها',
            dialog_content: 'محتوای دیالوگ',
            on_review_email_content: 'محتوای ایمیل در حال بررسی',
            status: 'وضعیت',
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش نوع احراز هویت'
    }
}
